export const getAvailableClusterZoomLevels = (clusterIndex, selectedLocationsSet) => {
    if (!clusterIndex || !clusterIndex.availableZoomLevels) {
        return [];
    }

    let maxZoom = Number.POSITIVE_INFINITY;
    let minZoom = Number.NEGATIVE_INFINITY;

    const adjust = zoneId => {
        try {
            const cluster = clusterIndex.getClusterById(zoneId);

            if (cluster) {
                minZoom = Math.max(minZoom, cluster.zoom);
                maxZoom = Math.min(maxZoom, cluster.zoom);
            } else {
                const zoom = clusterIndex.getMinZoomForLocation(zoneId);
                if (zoom !== null) {
                    minZoom = Math.max(minZoom, zoom);
                }
            }
        } catch (error) {
            console.warn('Error adjusting zoom level for location:', zoneId, error);
        }
    };

    if (selectedLocationsSet.size) {
        selectedLocationsSet.forEach(id => {
            adjust(id);
        });
    }

    const filteredLevels = clusterIndex.availableZoomLevels.filter(level => minZoom <= level && level <= maxZoom);

    // If no levels match the selection criteria, return all available levels
    if (filteredLevels.length === 0) {
        return clusterIndex.availableZoomLevels;
    }

    return filteredLevels;
};
